// Инициализируем RxDB плагины в самом начале
import './db/plugins';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { DatabaseProvider } from './contexts/DatabaseContext';
import { initAnalyticsIfAllowed } from './utils/cookieUtils';

// Проверка URL при загрузке страницы
(function checkAndRedirectUrl() {
  const currentPath = window.location.pathname;
  // Если мы открываем приложение напрямую через URL
  if (currentPath !== "/" && // Не делаем редирект с лендинга
      currentPath !== "/auth/login" && // Пропускаем аутентификацию
      currentPath !== "/auth/register" &&
      currentPath !== "/auth/email-confirmation" &&
      currentPath !== "/auth/setup-nickname" &&
      currentPath !== "/privacy-policy" &&
      currentPath !== "/editor-demo") {
    
    const timestamp = Date.now();
    
    // Проверяем и корректируем URL до рендеринга приложения
    if (currentPath === "/studio" || currentPath === "/dashboard") {
      // Оставляем пользователя на studio/dashboard без перенаправления
      return;
    } else if (currentPath === "/knowledge") {
      window.location.replace("/knowledge/root");
      return;
    } else if (currentPath === "/chat") {
      window.location.replace(`/chat/default-${timestamp}`);
      return;
    } else if (currentPath === "/roadmap") {
      window.location.replace(`/roadmap`);
      return;

    } else if (currentPath.startsWith("/articles/")) {
      // Проверяем наличие параметров в пути статей
      const parts = currentPath.split("/");
      if (parts.length === 3) {
        // Специальная обработка для страницы reel
        if (parts[2] === "reels") {
          window.location.replace("/reels");
          return;
        }
        window.location.replace(`${currentPath}/new-${timestamp}`);
        return;
      }
    }
  }
})();

// Инициализируем аналитику если есть согласие пользователя
initAnalyticsIfAllowed();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <DatabaseProvider>
      <App />
    </DatabaseProvider>
  </StrictMode>
);
